import React, { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';
const contactInfo = [
    {
        icon: 'PhoneIcon',
        title: 'Call Us',
        value: '+61 404 706 121',
        sub: 'Mon–Fri, 9am–6pm AEST',
        href: 'tel:+61404706121',
    },
    {
        icon: 'EnvelopeIcon',
        title: 'Email Us',
        value: 'info@awakasha.com.au',
        sub: 'We reply within 24 hours',
        href: 'mailto:info@awakasha.com.au',
    },
    {
        icon: 'MapPinIcon',
        title: 'Find Us',
        value: 'Melbourne, Australia',
        sub: 'Serving all of Australia',
        href: '#map',
    },
    {
        icon: 'ClockIcon',
        title: 'Office Hours',
        value: 'Mon–Fri: 9am–6pm',
        sub: 'AEST (UTC+11)',
        href: null,
    },
];
export default function ContactInfoCards() {
    const sectionRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.querySelectorAll('.reveal-up').forEach((el) => {
                        el.classList.add('revealed');
                    });
                }
            });
        }, { threshold: 0.1 });
        if (sectionRef.current)
            observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);
    return (<div ref={sectionRef} className="bg-background py-12 lg:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* BENTO AUDIT: 4 cards, 4-col grid */}
        {/* Row 1: [col-1: Phone cs-1] [col-2: Email cs-1] [col-3: Location cs-1] [col-4: Hours cs-1] */}
        {/* Placed 4/4 ✓ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {contactInfo.map((item, i) => {
            const inner = (<div className={`reveal-up contact-card-hover bg-card border border-border/50 rounded-xl p-6 flex flex-col gap-3 h-full stagger-${i + 1}`}>
                <div className="w-11 h-11 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center">
                  <Icon name={item.icon} size={20} className="text-primary"/>
                </div>
                <div>
                  <p className="text-xs font-bold tracking-widest uppercase text-muted-foreground mb-1">{item.title}</p>
                  <p className="font-display text-lg font-semibold text-foreground leading-tight">{item.value}</p>
                  <p className="text-muted-foreground text-xs mt-1">{item.sub}</p>
                </div>
              </div>);
            return item.href ? (<a key={item.title} href={item.href} className="block">
                {inner}
              </a>) : (<div key={item.title}>{inner}</div>);
        })}
        </div>
      </div>
    </div>);
}
